// effectTimeline.js

/**
 * Timeline déclarative : mappe un progress [0,1] -> une valeur.
 * keyframes : [{ p, value, ease? }]
 *  - p : position dans le progress [0,1]
 *  - value : valeur cible à ce point
 *  - ease : easing appliqué sur le segment qui ARRIVE à ce keyframe (optionnel)
 *
 * Hors des bornes, la timeline clamp à la première / dernière valeur.
 */
export function createTimeline(keyframes) {
    const kfs = [...keyframes].sort((a, b) => a.p - b.p)
    const n = kfs.length

    return function sample(p) {
        if (n === 0) return 0
        if (p <= kfs[0].p) return kfs[0].value
        if (p >= kfs[n - 1].p) return kfs[n - 1].value

        // Recherche linéaire (n petit, inutile d'optimiser)
        for (let i = 0; i < n - 1; i++) {
            const a = kfs[i]
            const b = kfs[i + 1]
            if (p >= a.p && p <= b.p) {
                const span = b.p - a.p
                if (span <= 0) return b.value
                const t = (p - a.p) / span
                const eased = b.ease ? b.ease(t) : t
                return a.value + (b.value - a.value) * eased
            }
        }
        return kfs[n - 1].value
    }
}

// Easings
export const linear = (t) => t
export const easeInOut = (t) => t * t * (3 - 2 * t)
export const easeIn = (t) => t * t
export const easeOut = (t) => 1 - (1 - t) * (1 - t)
export const easeInQuart = (t) => t * t * t * t
export const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4)